import styles from '../common.scss';
import { t } from '~/utils/localization';
import { getAmountString } from '../helpers';
import InventoryCounterContainer from '~/containers/InventoryCounterContainer/InventoryCounterContainer';
import classNames from 'classnames';
import { InventoryCounterSize } from '~/components/InventoryCounter/InventoryCounter';

interface IShipDestructionContent {
    item: IBundleEntity;
    quantity: number;
}

export const ShipDestructionContent = (props: IShipDestructionContent) => {
    const text = getAmountString(props.quantity, '<b>', '</b>');

    return (
        <div className={styles.flex}>
            <div className={styles.preBundleTitle}>{t('Эффект уничтожения вражеского корабля')}</div>
            <div className={styles.preBundleTitle} dangerouslySetInnerHTML={{ __html: text }} />
            <InventoryCounterContainer item={props.item} className={classNames(styles.preBundleTitle, styles.inventoryWidget)} size={InventoryCounterSize.FULL} />
        </div>
    );
};
